var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "last_area" } }, [
    _vm.getHasRegistration === "new"
      ? _c("div", { staticClass: "message_area" }, [
          _vm._v("\n    お申込みが完了しました。"),
          _c("br"),
          _vm._v("\n    タブレットを担当者へお渡しください。\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.getHasRegistration === "add"
      ? _c("div", { staticClass: "message_area" }, [
          _vm._v("\n    追加の手続きが完了しました。"),
          _c("br"),
          _vm._v("\n    タブレットを担当者へお渡しください。\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.getHasRegistration === "change"
      ? _c("div", { staticClass: "message_area" }, [
          _vm._v("\n    内容変更の手続きが完了しました。"),
          _c("br"),
          _vm._v("\n    タブレットを担当者へお渡しください。\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.getHasRegistration === "new"
      ? _c(
          "div",
          { staticClass: "next" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-arrow-right" },
                on: { click: _vm.homeTransition }
              },
              [_vm._v("Topページへ戻る")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.getHasRegistration === "add"
      ? _c(
          "div",
          { staticClass: "next" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-arrow-right" },
                on: { click: _vm.homeTransition }
              },
              [_vm._v("Topページへ戻る")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.getHasRegistration === "change"
      ? _c(
          "div",
          { staticClass: "next" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-arrow-right" },
                on: { click: _vm.listTransition }
              },
              [_vm._v("ご契約情報一覧へ戻る")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }